export default __webpack_public_path__ + "static/media/x-mass-title.a3a7b549.png";